'use client'

import { useEffect } from 'react'

declare global {
  interface Window {
    FB: {
      ui: (
        params: {
          method: 'share'
          hashtag?: string
          href: string
          display?: string
        },
        callback: (response: { error_message?: string }) => void
      ) => void
      init: (params: { appId: string; version: string }) => void
    }
  }
}

const FACEBOOK_APP_ID = '2106680276431596'
const FACEBOOK_SDK_VERSION = 'v12.0'

export function FacebookSDK() {
  useEffect(() => {
    // Check if SDK is already loaded
    if (window.FB) {
      return
    }

    // Load Facebook SDK
    const script = document.createElement('script')
    script.src = `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=${FACEBOOK_SDK_VERSION}&appId=${FACEBOOK_APP_ID}`
    script.async = true
    script.defer = true
    script.crossOrigin = 'anonymous'
    script.id = 'facebook-jssdk'

    // Initialize FB after script loads
    script.onload = () => {
      if (window.FB) {
        window.FB.init({
          appId: FACEBOOK_APP_ID,
          version: FACEBOOK_SDK_VERSION,
        })
      }
    }

    document.body.appendChild(script)

    return () => {
      // Cleanup: Remove script if component unmounts
      const existingScript = document.getElementById('facebook-jssdk')
      if (existingScript) {
        document.body.removeChild(existingScript)
      }
    }
  }, [])

  return null
}



